<template>
  <div class="moon-constellation white-wrapper mt-3">
    <h5 class="mb-3 font-weight-bold border-bottom pb-2">
      <img src="https://vk.com/emoji/e/e29ca8_2x.png" class="title-icon"/>
      Созвездие
    </h5>

    <div class="moon-constellation__description">
      <p>{{ sentences[0] }}</p>
      <accordion>
        <div slot="body">
          <p v-for="s in sentences.slice(1, sentences.length)" :key="s.length + Math.random()">
            {{ s }}
          </p>
        </div>
      </accordion>
    </div>
  </div>
</template>

<script>
import {store} from "@/store";
import stringHelper from "@/lib/string";
import Accordion from "@/components/_Utlis/Accordion";

export default {
  name: "MoonConstellationWidget",
  components: {Accordion},
  data() {
    return {
      sentences: [],
    }
  },
  created() {
    this.sentences = stringHelper.generateText(this.moonConstellationData);
  },
  computed: {
    moonConstellationData() {
      return store.state.moonDayInfo["description_moon_in_sign"];
    },
  }
}
</script>

<style lang="scss" scoped>
  .title-icon {
    width: 16px;
    height: auto;
    margin-top: -3px;
  }

  .moon-constellation__info {
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 500;
    padding: 4px 10px;
    border: 1px solid #bdbdbd;
    border-radius: .5rem;
    margin-bottom: 14px;

    & img {
      margin-right: 7px;
    }
  }

  .moon-constellation__info-positive {
    background: #c8e6c9;
    border-color: #a5d6a7;
  }

  .moon-constellation__info-neutral {
    background: #f5f5f5;
    border-color: #eeeeee;
  }

  .moon-constellation__info-negative {
    background: #ffcdd2;
    border-color: #ef9a9a;
  }

  .moon-constellation__info-description {

  }
</style>